import React from 'react';
import classes from './spinner.css';

const Spinner = () => {
  return <div className={classes.Spinner} />;
};

export default Spinner;



// WEBPACK FOOTER //
// ./src/Components/Spinner/Spinner.js